"use strict";

exports.cleanSlug = function (slug) {
  if (!slug) {
    return null;
  }
  return slug.replace(/^\/+|\/+$/g, '');
};